<template lang="pug">
  .coupon(:class="{ active, disabled }")
    a.checkbox(href @click.prevent.stop="toggle")
      svg(
        v-if="active"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      )
        //- d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        //- d="M5 13l4 4L19 7"
        path(
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.3"
          d="M5 13l4 4L19 7"
        )
      //-  svg(
      //-    v-if="active"
      //-    xmlns="http://www.w3.org/2000/svg"
      //-    viewBox="0 0 20 20"
      //-    stroke="currentColor"
      //-  )
      //-    path(
      //-      fill-rule="evenodd"
      //-      clip-rule="evenodd"
      //-      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
      //-    )
      .empty-checkbox(v-else)
        .circle
        //- svg(
        //-   xmlns="http://www.w3.org/2000/svg"
        //-   viewBox="0 0 20 20"
        //-   fill="currentColor"
        //- )
        //-   path(
        //-     fill-rule="evenodd"
        //-     d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
        //-     clip-rule="evenodd"
        //-   )
      label {{ label }}
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { moneyFormat } from '@/filters';

import { get } from '@/helpers';

export default {
  name: 'Coupon',
  props: {
    coupon: {
      type: Object,
      required: true
    }
  },
  // data: () => ({
  //   active: false
  // }),
  computed: {
    label() {
      let label = this.coupon.name;

      if (!label) {
        switch (this.coupon.type) {
          case 'percentage':
            label = `${this.coupon.percentage}% auf den gesamten Einkauf`;
            break;

          default:
          case 'fixed': {
            const code =
              get(this.customer, 'customerGroup.currency.iso4217') ||
              get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
              'EUR';

            let key = 'amount';
            if (this.customer && this.customer.show_net_prices) key = 'net_amount';
            label = `Rabatt: ${moneyFormat(this.coupon[key], code)}`;
            break;
          }
        }
      }

      return label;
    },
    active: {
      get() {
        let active = false;
        if (this.checkout.form.coupons?.length) {
          active = !!this.checkout.form.coupons.find(el => el.id === this.coupon.id);
        }
        return active;
      },
      set(value) {
        if (value === true) this.add(this.coupon);
        else this.remove(this.coupon);
      }
    },
    disabled() {
      let disabled = false;
      if (!this.active && this.checkout.form.coupons?.length) {
        disabled = !!this.checkout.form.coupons.find(el => {
          if (el.id === this.coupon.id) return;

          let el_pos = (el.position || Infinity) + parseFloat(`0.${el.id}`);
          let coupon_pos = (this.coupon.position || Infinity) + parseFloat(`0.${this.coupon.id}`);

          return el_pos <= coupon_pos && el.discard_the_following_coupons;
        });
      }
      return disabled;
    },
    ...mapGetters({
      checkout: 'shop/checkout',
      customer: 'shop/customer',
      defaultCustomerGroup: 'shop/defaultCustomerGroup',
      cms: 'CMS'
    })
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
    ...mapMutations({
      add: 'shop/addCouponToCheckoutForm',
      remove: 'shop/removeCouponFromCheckoutForm'
    })
  }
};
</script>

<style lang="sass" scoped>
.coupon
  @apply mb-2
  .empty-checkbox
    @apply flex justify-center items-center
    width: 1.5rem
    height: 1.5rem
    .circle
      @apply border-2 border-gray-400 bg-gray-100
      width: 1.2rem
      height: 1.2rem
      border-radius: 50%
  a.checkbox
    @apply p-2 rounded bg-gray-200
    border: 2px solid var(--color-primary)
    color: var(--color-primary)
    display: flex
    align-items: center
    width: 100%
    min-height: 2rem
    text-decoration: none
    transition: background-color .15s ease, color .15s ease
    &:hover,
    &:focus
      border: 2px solid var(--color-primary)
      background-color: var(--color-primary)
      --switch:calc((var(--primary-color-light-l) - var(--contrastThreshold)) * -100)
      color: hsl(0, 0%, var(--switch))
      .circle
        border-color: var(--color-primary)
    svg
      width: 1.5rem
      height: 1.5remo
      flex-shrink: 0
      // transition: color .15s ease
    label
      margin-left: 0.5rem
      line-height: 1.3
      padding-top: 3px
      cursor: pointer
  &.disabled
    opacity: 0.5
    pointer-events: none
  &.active
    a.checkbox
      @apply bg-green-200 border-green-300
      color: initial
      svg
        @apply text-green-600
      &:hover,
      &:focus
        @apply bg-gray-200 border-gray-300
        svg
          @apply text-gray-600
</style>
